import type { ReadSelectField } from '@cli-types/next-adapter/generators.js'
import { renderBuildReadSelectOptionTypeComponentTemplate } from '@next-adapter/templates/renderers/generators/actions/action-helpers/build-read-select-option-type.js'
export function buildReadSelectOptionType(selectFields: ReadSelectField[]): string | null {
  if (selectFields.length === 0) return null

  return renderBuildReadSelectOptionTypeComponentTemplate()
}
